function convertCubicYardToCubicFoot(num) {
  let eq =
    "Converting " +
    num +
    " cubic yard to cubic foot: \n" +
    num +
    " * 27 = ";
  let rep = num * 27;
  return eq + rep.toFixed(2);
}

function convertCubicYardToCubicInch(num) {
  let eq =
    "Converting " +
    num +
    " cubic yard to cubic inch: \n" +
    num +
    " * 46656 = ";
  let rep = num * 46656;
  return eq + rep.toFixed(2);
}

function convertCubicYardToCubicMeter(num) {
  let eq =
    "Converting " +
    num +
    " cubic yard to cubic meter: \n" +
    num +
    " * 0.764554858 = ";
  let rep = num * 0.764554858 ;
  return eq + rep.toFixed(3);
}

function convertCubicYardToCubicMile(num) {
  let eq =
    "Converting " +
    num +
    " cubic yard to cubic mile: \n" +
    num +
    " * 1.834264651e-10 = ";
  let rep = num * 1.834264651e-10;
  return eq + rep.toFixed(10);
}

function convertCubicYardToLiter(num) {
  let eq =
    "Converting " +
    num +
    " cubic yard to liter: \n" +
    num +
    " * 764.554858 = ";
  let rep = num * 764.554858;
  return eq + rep.toFixed(3);
}

export {
  convertCubicYardToLiter,
  convertCubicYardToCubicMile,
  convertCubicYardToCubicMeter,
  convertCubicYardToCubicInch,
  convertCubicYardToCubicFoot
};
